__turbopack_context__.v({
  "component": "W_Wxsq_component",
  "componentMobileReverse": "W_Wxsq_componentMobileReverse",
  "component__background": "W_Wxsq_component__background",
  "component__backgroundMobile": "W_Wxsq_component__backgroundMobile",
  "component__backgroundWrap": "W_Wxsq_component__backgroundWrap",
  "component__backgroundWrapContain": "W_Wxsq_component__backgroundWrapContain",
  "component__backgroundWrapReverse": "W_Wxsq_component__backgroundWrapReverse",
  "component__background_img": "W_Wxsq_component__background_img",
  "component__buttonStyle": "W_Wxsq_component__buttonStyle",
  "component__content": "W_Wxsq_component__content",
  "component__contentReverse": "W_Wxsq_component__contentReverse",
  "component__copy": "W_Wxsq_component__copy",
  "component__copyContainer": "W_Wxsq_component__copyContainer",
  "component__icon": "W_Wxsq_component__icon",
  "component__icon__dark": "W_Wxsq_component__icon__dark",
  "component__icon__red": "W_Wxsq_component__icon__red",
  "component__itemHeading": "W_Wxsq_component__itemHeading",
  "component__legal": "W_Wxsq_component__legal",
  "component__list": "W_Wxsq_component__list",
  "component__subtitle": "W_Wxsq_component__subtitle",
  "component__title": "W_Wxsq_component__title",
  "hide-for-large": "W_Wxsq_hide-for-large",
  "hide-for-large-only": "W_Wxsq_hide-for-large-only",
  "hide-for-medium": "W_Wxsq_hide-for-medium",
  "hide-for-medium-only": "W_Wxsq_hide-for-medium-only",
  "hide-for-small-only": "W_Wxsq_hide-for-small-only",
  "show-for-large": "W_Wxsq_show-for-large",
  "show-for-large-only": "W_Wxsq_show-for-large-only",
  "show-for-medium": "W_Wxsq_show-for-medium",
  "show-for-medium-only": "W_Wxsq_show-for-medium-only",
  "show-for-small-only": "W_Wxsq_show-for-small-only",
  "u-color-black": "W_Wxsq_u-color-black",
  "u-color-blue": "W_Wxsq_u-color-blue",
  "u-color-midnight": "W_Wxsq_u-color-midnight",
  "u-color-primary-dark": "W_Wxsq_u-color-primary-dark",
  "u-color-red": "W_Wxsq_u-color-red",
  "u-color-white": "W_Wxsq_u-color-white",
  "u-theme-black": "W_Wxsq_u-theme-black",
  "u-theme-blue": "W_Wxsq_u-theme-blue",
  "u-theme-dark": "W_Wxsq_u-theme-dark",
  "u-theme-light": "W_Wxsq_u-theme-light",
  "u-theme-red": "W_Wxsq_u-theme-red",
  "u-theme-white": "W_Wxsq_u-theme-white",
});
